import React, { useState } from "react";
import useAuthentication from "./../components/HOC/useAuthentication";
import { sideBarItems } from "../utils";
import { BrowserRouter, Route, Switch, withRouter } from "react-router-dom";

const DashSidebar = (props) => {
  const { user, setUser } = useAuthentication();
  const { match, location, history } = props;

  const getItemCss = (title) => {
    return title === props.title
      ? "w-full font-thin uppercase text-blue-500 flex items-center p-4 my-2 transition-colors duration-200 justify-start bg-gradient-to-r from-blue-50 to-blue-200 border-r-4 border-blue-500 dark:from-gray-700 dark:to-gray-800 border-r-4 border-blue-500"
      : "w-full font-thin uppercase text-gray-500 dark:text-gray-200 flex items-center p-4 my-2 transition-colors duration-200 justify-start hover:text-blue-500";
  };

  const logout = () => {
    history.push("/");
    setUser(null);
  };

  return (
    <div className="flex flex-no-wrap ">
      <div
        // className="h-screen hidden lg:block shadow-lg relative w-60"
        className="w-64 absolute sm:relative bg-gray-800 shadow md:h-full flex-col justify-between hidden sm:flex"
      >
        <div className="bg-white h-full dark:bg-gray-700">
          <div className="dashboard_profile  pt-6">
            {/*image and name*/}
            <img
              className="dashboard_profile_icon h-12 w-12  rounded-full"
              src="data:image/svg+xml;base64,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"
            />
            <h4>
              {user.firstName} {user.lastName}
            </h4>
          </div>
          <nav className="mt-6">
            <div>
              <a
                className={getItemCss(sideBarItems.dashboard.key)}
                href="/dashboard"
              >
                <span className="text-left">
                  <i class="fas fa-tachometer-alt"></i>
                </span>
                <span className="mx-4 text-sm font-normal">
                  {sideBarItems.dashboard.value}
                </span>
              </a>

              <a
                className={getItemCss(sideBarItems.location.key)}
                href="/location"
              >
                <i class="fas fa-map-marker-alt"></i>

                <span className="mx-4 text-sm font-normal">
                  {sideBarItems.location.value}
                </span>
              </a>
              {/*<a*/}
              {/*  className={getItemCss(sideBarItems.route.key)}*/}
              {/*  href="/route">*/}

              {/*  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none"*/}
              {/*       viewBox="0 0 24 24" stroke="currentColor">*/}
              {/*    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"*/}
              {/*          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>*/}
              {/*    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"*/}
              {/*          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>*/}
              {/*  </svg>*/}

              {/*  <span className="mx-4 text-sm font-normal">*/}
              {/*                 {sideBarItems.route.value}*/}
              {/*              </span>*/}
              {/*</a>*/}
              <a className={getItemCss(sideBarItems.price.key)} href="/price">
                <span className="text-left">
                  <i class="fas fa-list-alt"></i>
                </span>
                <span className="mx-4 text-sm font-normal">
                  {sideBarItems.price.value}
                </span>
              </a>
              <a
                className={getItemCss(sideBarItems.booking.key)}
                href="/booking"
              >
                <span className="text-left">
                  <i class="fa-solid fa-bangladeshi-taka-sign"></i>
                </span>
                <span className="mx-4 text-sm font-normal">
                  {sideBarItems.booking.value}
                </span>
              </a>
              <a
                className={getItemCss(sideBarItems.driver.key)}
                href="/driverlist"
              >
                <span className="text-left">
                  <i class="fas fa-id-badge"></i>
                </span>
                <span className="mx-4 text-sm font-normal">
                  {sideBarItems.driver.value}
                </span>
              </a>
              <a className={getItemCss(sideBarItems.owner.key)} href="/owner">
                <span className="text-left">
                  <i class="fas fa-user-tie"></i>
                </span>
                <span className="mx-4 text-sm font-normal">
                  {sideBarItems.owner.value}
                </span>
              </a>
              <a
                className={getItemCss(sideBarItems.passenger.key)}
                href="/passengers"
              >
                <span className="text-left">
                  <i class="fas fa-users"></i>
                </span>
                <span className="mx-4 text-sm font-normal">
                  {sideBarItems.passenger.value}
                </span>
              </a>
              <a className={getItemCss(sideBarItems.trip.key)} href="/Triplist">
                <span className="text-left">
                  <i class="fas fa-car"></i>
                </span>
                <span className="mx-4 text-sm font-normal">
                  {sideBarItems.trip.value}
                </span>
              </a>

              <a
                className={getItemCss(sideBarItems.transaction.key)}
                href="/transaction"
              >
                <span className="text-left">
                  <i class="fas fa-money-bill"></i>
                </span>
                <span className="mx-4 text-sm font-normal">
                  {sideBarItems.transaction.value}
                </span>
              </a>
              <a className={getItemCss(sideBarItems.refund.key)} href="/refund">
                <span className="text-left">
                  <i class="fas fa-money-bill"></i>
                </span>
                <span className="mx-4 text-sm font-normal">
                  {sideBarItems.refund.value}
                </span>
              </a>
              <a
                className={getItemCss(sideBarItems.notifications.key)}
                href="/notifications"
              >
                <span className="text-left">
                  <i class="fas fa-bell"></i>
                </span>
                <span className="mx-4 text-sm font-normal">
                  {sideBarItems.notifications.value}
                </span>
              </a>

              <a className={getItemCss(sideBarItems.support.key)} href="/support">
                <span className="text-left">
                  <i class="fas fa-headset"></i>
                </span>
                <span className="mx-4 text-sm font-normal">
                  {sideBarItems.support.value}
                </span>
              </a>

              <a onClick={logout} className={getItemCss(sideBarItems.logout.key)} href="/">
                <span className="text-left">
                  <i class="fas fa-sign-out-alt"></i>
                </span>
                <span className="mx-4 text-sm font-normal">
                  {sideBarItems.logout.value}
                </span>
              </a>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default withRouter(DashSidebar);